var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c("h1", [_vm._v("Tasks")]),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g({ attrs: { color: "primary", dark: "" } }, on),
                        [_vm._v("Add new Task")]
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          staticClass: "inline-radiogroup",
                                          attrs: {
                                            rules: _vm.nameRules,
                                            label: "Type of price"
                                          },
                                          model: {
                                            value: _vm.editedItem.type,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editedItem,
                                                "type",
                                                $$v
                                              )
                                            },
                                            expression: "editedItem.type"
                                          }
                                        },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Fixed",
                                              value: "fixed",
                                              selected: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              "float-right": "",
                                              label: "Per hr",
                                              value: "hr"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Name",
                                      rules: _vm.nameRules,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.editedItem.name,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "name", $$v)
                                      },
                                      expression: "editedItem.name"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: { headers: _vm.headers, items: _vm.tasks, "items-per-page": 10 },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                item.type != "auto"
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit(item)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-pencil")
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                item.type != "auto"
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", small: "", color: "red" },
                        on: {
                          click: function($event) {
                            return _vm.deleteTask(item.id)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-delete-forever")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                item.type != "auto"
                  ? _c("v-switch", {
                      attrs: {
                        success: item.status == 1 ? true : false,
                        inset: "",
                        label: _vm.getUserSwitchLabel(item.status)
                      },
                      on: {
                        change: function($event) {
                          return _vm.updateStatus(item)
                        }
                      },
                      model: {
                        value: item.status,
                        callback: function($$v) {
                          _vm.$set(item, "status", $$v)
                        },
                        expression: "item.status"
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "orange", text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("\n                Close\n              ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.snackbartext) + " \n\n            "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }